import React from 'react';

import { NavLink } from 'react-router-dom';
 
const Portfolio = () => {
    return (
        <div className="bio-page">
         <div className="bio-nav">
            <div className="card">
               <NavLink to="/radio">
                  <h1>Radio</h1>
                  <img src={require('../img/Micro-logiciel.jpg')} alt={""} />
               </NavLink>
               </div>
            </div>
         <div className="bio-nav">
            <div className="card">
               <NavLink to="/doublage">
                  <h1>Doublage</h1>
                  <img src={require('../img/IMG-20190707-WA0008.jpg')} alt={""} />
               </NavLink>
            </div>
         </div>
         <div className="bio-nav">
            <div className="card">
               <NavLink to="/musique">
                  <h1>Musique</h1>
                  <img src={require('../img/IMG-20191012-WA0001.jpg')} alt={""} />
               </NavLink>  
            </div>
         </div>
        </div>
    );
}
 
export default Portfolio;